import { ProjectPortfolio } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { DuplicateInspector } from "../../adapters/duplicateInspector";
import { findError } from "../../../entities/errorChecker";
import { validateProjectPortfolio } from "../../entities/validateProjectPortfolio";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function hashCode(str: string) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();

  return "00000".substring(0, 6 - c.length) + c;
}

function generateRandomColor({ name }: ProjectPortfolio) {
  return `#${intToRGB(hashCode(name))}`;
}

function createInteractor(
  repository: Repository,
  inspector: DuplicateInspector,
): Interactor {
  return ({ planzone, portfolio }) => {
    const error = validateProjectPortfolio(portfolio);

    return present(
      !findError(error)
        ? inspector
            .isProjectPortfolioDuplicate(planzone, portfolio)
            .then((isDuplicated) =>
              !isDuplicated
                ? repository
                    .saveProjectPortfolio(planzone, {
                      ...portfolio,
                      color: portfolio.color || generateRandomColor(portfolio),
                    })
                    .then((portfolio) => ({ planzone, portfolio }))
                    .catch(() => Promise.reject({ planzone, portfolio, error }))
                : Promise.reject({
                    planzone,
                    portfolio,
                    error: { ...error, portfolioNameIsNotUnique: true },
                  }),
            )
        : Promise.reject({ planzone, portfolio, error }),
    );
  };
}

export type { Interactor };

export { createInteractor };
